import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MedicalServiceService } from '../../../services/medical-service.service';
import { NotificationToastService } from '../../../services/notification-toast.service';

@Component({
  selector: 'app-dialog-comment-pre-study-report',
  templateUrl: './dialog-comment-pre-study-report.component.html',
  styleUrls: ['./dialog-comment-pre-study-report.component.css']
})
export class DialogCommentPreStudyReportComponent implements OnInit {

  loading: boolean;
  comments: string;

  constructor(
    public dialogRef: MatDialogRef<DialogCommentPreStudyReportComponent>,
     private medicalServiceService: MedicalServiceService,
     private notificationToastService: NotificationToastService,
     @Inject(MAT_DIALOG_DATA) public medicalAppointmentId: number) {
     this.loading = true;
  }

  async ngOnInit() {
    try {
      this.comments = await this.medicalServiceService.getCommentPreStudyReport(this.medicalAppointmentId);
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Comentarios pre informe');
    }
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }
}
